import axios from "axios";
import { Theme } from "../../types/Settings";

export const getThemeSettings = (url: string) => axios.get<{ data: Theme }>(url +'/api/v1/get-style-list');
